<template>
    <div class="row">
        <div class="col-sm-5">
            <span class="font-weight-bold">{{pagination.total}}</span> registos encontrados<br>
            A mostrar página <span class="font-weight-bold">{{pagination.current_page}}</span> de <span class="font-weight-bold">{{pagination.total_pages}}</span> 
            <select class="ml-2" v-model="pagination.per_page" @change="reset()">
                <option :value="item" v-for="item in [5,10,25,50,100]">{{item}}</option>
            </select> 
            registos por página
        </div>
        <div class="col-sm-7">
            <nav class="pagination-outer">
                <ul class="pagination">
                    <li class="page-item" @click.prevent="changePage(1)" v-if="pagination.current_page > 1">
                        <a href="#" class="page-link" :style="{'background-color':$store.state.page.bg_color?$store.state.page.bg_color:'#b9b9b9','color':$store.state.page.text_color?$store.state.page.text_color:'#fff'}">
                            <span aria-hidden="true">««</span>
                        </a>
                    </li>        
                    <li class="page-item" @click.prevent="changePage(pagination.current_page - 1)" v-if="pagination.current_page > 1">
                        <a href="#" class="page-link" :style="{'background-color':$store.state.page.bg_color?$store.state.page.bg_color:'#b9b9b9','color':$store.state.page.text_color?$store.state.page.text_color:'#fff'}">
                            <span aria-hidden="true">«</span>
                        </a>
                    </li>        
                    <li class="page-item" :class="{'active':isCurrentPage(page)}" v-for="page in pages" @click.prevent="isCurrentPage(page)?null:changePage(page)">
                        <a class="page-link" href="#" :style="{'background-color':$store.state.page.bg_color?$store.state.page.bg_color:'#b9b9b9','color':$store.state.page.text_color?$store.state.page.text_color:'#fff'}">{{page}}</a>
                    </li>
                    <li class="page-item" @click.prevent="changePage(pagination.current_page + 1)" v-if="pagination.current_page < pagination.last_page">
                        <a href="#" class="page-link" aria-label="Next" :style="{'background-color':$store.state.page.bg_color?$store.state.page.bg_color:'#b9b9b9','color':$store.state.page.text_color?$store.state.page.text_color:'#fff'}">
                            <span aria-hidden="true">»</span>
                        </a>
                    </li>
                    <li class="page-item" @click.prevent="changePage(pagination.last_page)" v-if="pagination.current_page < pagination.last_page">
                        <a href="#" class="page-link" aria-label="Next" :style="{'background-color':$store.state.page.bg_color?$store.state.page.bg_color:'#b9b9b9','color':$store.state.page.text_color?$store.state.page.text_color:'#fff'}">
                            <span aria-hidden="true">»»</span>
                        </a>
                    </li>
                </ul>
            </nav>      
        </div>    
    </div>
</template>

<script>
    export default {
        props: ['pagination', 'offset'],
        methods: {
            isCurrentPage(page) {
                return this.pagination.current_page === page;
            },
            changePage(page) {
                if (page > this.pagination.last_page) {
                    page = this.pagination.last_page;
                }
                this.pagination.current_page = page;
                this.$emit('paginate');
            },
            reset: function(){
                this.pagination.current_page = 1;
                this.$emit('paginate');
            }
        },
        computed: {
            pages() {
                let pages = [];
                let from = Math.floor(this.pagination.current_page / this.offset)*this.offset;
                let to = from+this.offset-1;
                if (to > this.pagination.last_page) 
                {
                    to = this.pagination.last_page;
                }
                if(from == 0)
                {
                    from = 1;
                }
                while (from <= to) {
                    pages.push(from);
                    from++;
                }
                return pages;
            }
        }
    }
</script>

<style scoped lang="scss">
    .pagination-outer{ text-align: right; }
    .pagination{
        display: inline-flex;
        border-radius: 0;
        overflow: hidden;
        position: relative;
    }
    .pagination li a.page-link{
        width: auto;
        height: 25px;
        line-height: 10px;
        border-radius: 0;
        border: none;
        background: #b9b9b9;
        font-size: 12px;
        font-weight: 700;
        
        letter-spacing: 1px;
        text-transform: uppercase;
        z-index: 1;
        margin: 5px;
        position: relative;
        transition: all 0.4s ease 0s;
    }
    .pagination li.active a.page-link,
    .pagination li a.page-link:hover,
    .pagination li.active a.page-link:hover{
        
        background: transparent;
    }
    .pagination li a.page-link:before{
        content: "";
        height: 0;
        border-left: 3px solid #b9b9b9;
        border-right: 3px solid #b9b9b9;
        position: absolute;
        top: 50%;
        left: -2px;
        right: -2px;
        transform: translateY(-50%);
        transition: all 0.3s ease 0s;
    }
    .pagination li a.page-link:hover:before,
    .pagination li.active a.page-link:before{ height: 50%; }
    .pagination li a.page-link:after{
        content: "";
        width: 0;
        border-top: 3px solid #b9b9b9;
        border-bottom: 3px solid #b9b9b9;
        margin: 0 auto;
        position: absolute;
        top: -2px;
        bottom: -2px;
        left: 0;
        right: 0;
        transition: all 0.3s ease 0s;
    }
    .pagination li a.page-link:hover:after,
    .pagination li.active a.page-link:after{ width: 60%; }
    @media only screen and (max-width: 480px){
        .pagination{ display: block; }
        .pagination li{
            display: inline-block;
            margin-bottom: 10px;
        }
    }   
</style>